/**
 * @file Branded logo header for folder discovery.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Header from '../../global/Header';
import LogoPoweredBy from '../../global/LogoPoweredBy';

const propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  logo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
};

const OnboardingBrandedHeader = ({ logo, title, className }) => {
  const classes = classNames({
    'header-shadow': true,
    [className]: !!className,
  });

  return logo ? (
    <Header className={classes}>
      <div className="site-branded-header">
        <img src={logo.url} alt="" className="site-brand-user-brand-logo" />
        {title && <h3 className="text-base site-title-center">{title}</h3>}
        <LogoPoweredBy className="site-brand-user-waldo-logo ml-auto" />
      </div>
    </Header>
  ) : null;
};

OnboardingBrandedHeader.propTypes = propTypes;

export default OnboardingBrandedHeader;
